<template>
	<div>
		<div>
            <div style="cursor: pointer;">
                <div
                    class="flex"
                    v-on:click="() => this.show = !this.show"
                >
                    <div
                        class="mr-2"
                    >
                        Menu
                    </div>
                    <svg v-if="show" width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"/></svg>
                    <svg v-else version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 51.388 51.388" style="width: 15px; margin-top: 3px;"
                         xml:space="preserve">
                        <g>
                            <g>
                                <path d="M9.169,51.388c-0.351,0-0.701-0.157-0.93-0.463c-0.388-0.514-0.288-1.243,0.227-1.634l31.066-23.598L8.461,2.098
                                    C7.95,1.708,7.85,0.977,8.237,0.463c0.395-0.517,1.126-0.615,1.64-0.225l33.51,25.456L9.877,51.151
                                    C9.664,51.31,9.415,51.388,9.169,51.388z"/>
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
            <div
                v-if="show"
            >
                <ul>
                    <li>
                        <router-link
                            to="/super"
                        >
                            Admin Home
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            to="/super/contests/create"
                        >
                            Create New Contest
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="'/super/contests'">View All Contests</router-link>
                    </li>
                    <ul
                        class="ml-4"
                        v-if="showSubMenu"
                    >
                        <li>
                            <router-link :to="'/super/contests/' + this.$route.params.contest">
                                {{ this.contest ? this.contest.title : this.$route.params.contest }}
                            </router-link>
                        </li>
                        <ul>
                            <li>
                                <router-link :to="'/super/contests/' + this.$route.params.contest">
                                    View Contest
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="'/super/contests/' + this.$route.params.contest + '/update'">
                                    Update Contest
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="'/super/contests/' + this.$route.params.contest + '/entries'">Entries
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="'/super/contests/' + this.$route.params.contest + '/entries/create'">
                                    Create Entry
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="'/super/contests/' + this.$route.params.contest + '/create-category'">
                                    Create Category
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="'/super/contests/' + this.$route.params.contest + '/forms'">Forms
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="'/super/contests/' + this.$route.params.contest + '/api-creation'">Create
                                    Api
                                </router-link>
                            </li>

                            <li>
                                <router-link :to="'/contests/' + this.$route.params.contest + '/free-entry'">
                                    Create Free Entry
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="'/super/contests/' + this.$route.params.contest + '/subscriptions-table'">
                                    View Subscriptions Table
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="'/super/contests/' + this.$route.params.contest + '/purchases-table'">View
                                    Purchases Table
                                </router-link>
                            </li>
                        </ul>
                    </ul>
                </ul>
            </div>
		</div>
	</div>
</template>
<script>

export default {
	name: 'super-header',

	components: {},
	data() {
		return {
			places: null,
			displayMobileFilters: false,
			show: false,
		}

	},
	computed: {
		user() {
			return this.$store.state.user;
		},
		showSubMenu() {
			console.log('showSubMenu', this.$route.params)
			return this.$route.params && this.$route.params.contest;
		},
		contest() {
			return this.$store.state.contest;
		}
	},
}
</script>

<style lang="scss">

</style>
